
import { PathsToEnemyCalculator } from "@/core/battle/ai/calculators/PathsToEnemyCalculator";
import { PlanningContext, ActionCandidate, PlanningState, AIActionType, IActionGenerator, IEvaluator, TacticalNode } from "@/core/battle/ai/types/ai.types";
import ManagerRegistry from "@/core/battle/ManagerRegistry";
import { PathCalculator } from "@/core/battle/PathCalculator";
import { Hex, PathInfo, TerrainType } from "@/core/types/battle.types";
import { coordsToId, idToCoords } from "@/core/utils/hex.utils";

export class MoveActionGenerator implements IActionGenerator {
    public generatorType: AIActionType = AIActionType.Move;
    // constructor(
    //     private evaluator: PositionEvaluator
    // ) {}

    public generate(state: PlanningState, ctx: PlanningContext, movementEvaluator: IEvaluator<PathInfo>): ActionCandidate[] {
        const candidates: ActionCandidate[] = [];
        const registry = ManagerRegistry.getInstance().entityRegistry;
        const currentHexId = coordsToId(state.position);
        const startHexId = coordsToId(ctx.unit); // Початкова позиція на початку ходу

        let activeReachableMap: Map<string, number>;
        let activeParentMap: Map<string, string | null>;

        // 1. ПЕРЕВІРКА АКТУАЛЬНОСТІ КАРТИ
        if (currentHexId === startHexId) {
            // Це перший рух. Використовуємо кешовані карти з контексту (найшвидший варіант)
            activeReachableMap = ctx.reachableMap;
            activeParentMap = ctx.parentMap;
        } else {
            // Це другий/третій рух (наприклад, після Attack).
            // Поточна позиція змінилася. Кеш не валідний.
            // Будуємо "міні-карту" на залишок стаміни (дуже швидка операція)
            const localData = PathCalculator.getReachableNodes(state.position, {currentStamina: state.stamina, speed: ctx.unit.stats.speed}, ctx.battleMap);
            activeReachableMap = localData.reachableMap;
            activeParentMap = localData.parentMap;
        }

        // 2. ГЕНЕРАЦІЯ КАНДИДАТІВ
        for (const [targetHexId, moveCost] of activeReachableMap.entries()) {
            if (moveCost === 0 || currentHexId === targetHexId) continue;

            // Тепер reconstructPath завжди працює правильно, 
            // бо activeParentMap побудована саме від currentHexId
            const path = PathsToEnemyCalculator.reconstructPath(targetHexId, activeParentMap);

            const pathInfo: PathInfo = {
                path: path,
                cost: moveCost,
                lastStep: { id: targetHexId, terrain: ctx.battleMap.get(targetHexId)?.terrain || TerrainType.Plains }
            };

            // Тут ми викликаємо твій movementEvaluator, який поверне { utility: accessibility }
            const evalResult = movementEvaluator.evaluate(state, ctx, pathInfo);
            const targetPos: { q: number; r: number; } = registry.getHex(targetHexId)?.data ?? idToCoords(targetHexId);
            candidates.push({
                action: {
                    type: AIActionType.Move,
                    unitId: ctx.unit.unitId,
                    targetHexId: targetHexId,
                    targetPath: pathInfo,
                    utility: evalResult.utility // Твій 1 - zocRisk
                },
                utility: evalResult.utility, 
                staminaAfter: state.stamina - moveCost,
                position: targetPos,
                components: evalResult.components
            });
        }

        return candidates;
    }

    // public generate(state: PlanningState, ctx: PlanningContext, evaluator: IEvaluator<PathInfo>): ActionCandidate[] {
    //     // Генерируем точки перемещения
    //     const candidates: ActionCandidate[] = [];
    //     const startId = coordsToId(state.position);
    //     const { battleMap, reachableMap } = ctx;

    //     for (const [hexId, moveCost] of reachableMap.entries()) {
    //         if (hexId === coordsToId(state.position)) continue;
            
    //         const target = battleMap.get(hexId);
    //         if (!target || target.isObstacle || (target.entityId && hexId !== startId)) continue;
            
    //         const pathData = ctx.pathHexes.get(hexId);

    //         // 1. Восстанавливаем путь (Backtracking)
    //         const path: string[] = [];
    //         let current: string | null = hexId;
    //         while (current !== null && current !== startId) {
    //             path.push(current);
    //             current = ctx.parentMap.get(current) || null;
    //         }
    //         const reversedPath = path.reverse();

    //         const lastStep = {id: hexId, terrain: target.terrain}

    //         // 2. Формируем PathInfo
    //         const pathInfo: PathInfo = {
    //             path: reversedPath,
    //             lastStep: lastStep,
    //             cost: moveCost // Это значение из reachableMap
    //         };

    //         // 3. Передаем PathInfo в эвалюатор
    //         // Теперь эвалюатор может анализировать длину пути или промежуточные клетки
    //         const evalResult = evaluator.evaluate(state, ctx, pathInfo);

    //         const newPos = idToCoords(hexId);
    //         // const [q, r] = hexId.split(':').map(Number);
            
    //         candidates.push({
    //             action: {
    //                 type: AIActionType.Move,
    //                 unitId: ctx.unit.unitId,
    //                 targetHexId: hexId,
    //                 targetPath: pathInfo,
    //             },
    //             utility: evalResult.utility,
    //             staminaAfter: state.stamina - moveCost,
    //             position: newPos,
    //             components: {
    //                 ...evalResult.components,
    //                 total: evalResult.utility,
    //             },
    //             metadata: {
    //                 type: pathData ? 'path-based' : 'opportunistic',
    //                 pathAlignment: !!pathData,
    //             },
    //         });
    //     }

    //     return candidates;
    // }
}